import type Guid from "_shared/guids/guid";
import CalendarEventAccessSchema, {
  CalendarEventAccessJSON,
  CalendarEventAccessParams,
} from "permissions/resources/calendar/_schemas/calendar-event-access-schema";
import { Resource } from "permissions/resources/permission-resource";
import { registerResource } from "permissions/resources/resource-registry";
import { AccessLevel, AnyResourceJSON, ResourceFromJSON, ResourceType } from "permissions/resources/permission-resource-types";

export class CalendarEventAccess extends Resource {
  public static create(params?: CalendarEventAccessParams): CalendarEventAccess {
    return new CalendarEventAccess(CalendarEventAccessSchema.validate(params));
  }

  public static fromJSON<J extends AnyResourceJSON>(json: J): ResourceFromJSON<J> {
    const parsed = CalendarEventAccessSchema.deserialize(json as CalendarEventAccessJSON);
    return new CalendarEventAccess(parsed) as ResourceFromJSON<J>;
  }

  public readonly resourceType = ResourceType.CalendarEventAccess;
  public readonly accessLevel?: AccessLevel;
  /** The calendar event the grant opens; the server's `CalendarEventAccess.CalendarEventId`. */
  public readonly calendarEventId?: Guid;

  public constructor(params?: CalendarEventAccessParams) {
    super(params);
    this.accessLevel = params?.accessLevel;
    this.calendarEventId = params?.calendarEventId;
  }

  public toJSON(): CalendarEventAccessJSON {
    return CalendarEventAccessSchema.serialize(this);
  }

  public override toString(): string {
    return `CalendarEventAccess {
      resourceType: ${this.resourceType}
      resourceId: ${this.resourceId?.value}
      isDisabled: ${this.isDisabled ? "true" : "false"}
      accessLevel: ${this.accessLevel}
      calendarEventId: ${this.calendarEventId?.value}
    }`;
  }
}

registerResource("CalendarEventAccess", (json) => CalendarEventAccess.fromJSON(json));
